import React from 'react'
import { useState } from 'react'
import { CiSettings } from "react-icons/ci";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { FaEnvelope } from "react-icons/fa";


function Emailsetting() {
    const [login, setlogin] = useState(false)
    const [Notification, setNotification] = useState(false)
    const [Registration, setRegistration] = useState(false)
    return (
        <>
            <div className='w-[100%] flex mt-2 flex-col md:flex-row'>

                <div className='w-[100%] md:w-[15%] py-3 border-r-[0px] md:border-r-[1px] border-[#c9c3c3]'>
                    <button className='text-[#448c74] text-[13px] font-semibold flex items-center gap-1 py-2 px-2 border-b-[2px] border-[#448c74]'>
                        <FaEnvelope />
                        Common Email
                    </button>
                </div>
                <div className=' className=w-[100%] md:w-[75%] '>
                    <div className='w-[100%]  flex flex-col md:flex-row justify-between items-start md:items-center pl-0 md:pl-4 gap-4'>

                        {/* Toggle 1 */}
                        <div className='flex items-center gap-4 flex-wrap'>
                            <button
                                onClick={() => setlogin(!login)}
                                className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${login ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
                            >
                                <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${login ? "translate-x-[13px]" : ""}`}></div>
                            </button>
                            <span
                                onClick={() => setlogin(!login)}
                                className='text-[#576071] text-[12px] '>
                                Login Notification Email
                            </span>
                        </div>

                        {/* Toggle 2 */}
                        <div className='flex items-center gap-4 flex-wrap'>
                            <button
                                onClick={() => setNotification(!Notification)}
                                className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${Notification ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
                            >
                                <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${Notification ? "translate-x-[13px]" : ""}`}></div>
                            </button>
                            <span
                                onClick={() => setNotification(!Notification)}
                                className='text-[#576071] text-[12px] '>
                                Credit Notification Email
                            </span>
                        </div>

                        {/* Toggle 3 */}
                        <div className='flex items-center gap-4 flex-wrap'>
                            <button
                                onClick={() => setRegistration(!Registration)}
                                className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${Registration ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
                            >
                                <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${Registration ? "translate-x-[13px]" : ""}`}></div>
                            </button>
                            <span
                                onClick={() => setRegistration(!Registration)}
                                className='text-[#576071] text-[12px] '>
                                New User Registration Email </span>
                        </div>
                    </div>
                    <div className='pl-4 pt-4'>
                        <button className='bg-[#31b07b] text-[#fff] py-2 text-[11px] px-2 rounded-md font-bold'>Save All Settings</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Emailsetting
